import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

import { computed, useTemplateRef } from 'vue';
import { LMap, LTileLayer, LMarker, LIcon } from '@vue-leaflet/vue-leaflet';
import { latLngBounds } from 'leaflet';

import { config } from '@services/user-config';

import 'leaflet/dist/leaflet.css';
import 'leaflet-edgebuffer';

const OSM_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
const OSM_ATTRIBUTION = '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapStandalone',
  props: {
    center: {},
    zoom: { default: 14 },
    pins: {},
    scrollWheelZoom: { type: Boolean, default: false }
  },
  emits: ["ready", "moveend", "zoomend"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

/** Main map instance and configuration */
const map = useTemplateRef<InstanceType<typeof LMap>>('map');
const mapOptions = computed(() => ({
  maxBounds: latLngBounds([-90, -180], [90, 180]),
  maxBoundsViscosity: 0.9,
  scrollWheelZoom: props.scrollWheelZoom,
}));

/** Static pins configuration */
const markerOptions = {
  interactive: false,
  keyboard: false,
};

/** Tile layer configuration */
const tileServer = computed(() => {
  const tiles = config.map_tile_servers || [];
  return tiles.find((t) => t.url === config.map_tile_server_url);
});
const tileurl = computed(() => {
  return config.map_tile_server_url || OSM_TILE_URL;
});
const attribution = computed(() => {
  return tileServer.value?.attribution || OSM_ATTRIBUTION;
});
const tileLayerOptions = computed(() => ({
  referrerPolicy: 'origin',
  maxZoom: tileServer.value?.maxZoom ?? 19,
  maxNativeZoom: tileServer.value?.maxZoom ?? 19,
}));

function onReady(map: NonNullable<InstanceType<typeof LMap>['leafletObject']>) {
  emit('ready', map);
}

function getMap() {
  return map.value?.leafletObject;
}

__expose({ getMap });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LMap), {
    ref_key: "map",
    ref: map,
    class: "map-standalone-map",
    center: __props.center,
    zoom: __props.zoom,
    minZoom: 2,
    maxZoom: tileLayerOptions.value.maxZoom,
    options: mapOptions.value,
    crossOrigin: true,
    onReady: onReady,
    onMoveend: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('moveend'))),
    onZoomend: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('zoomend'))),
    onTouchstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
    onTouchmove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    onTouchend: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    onTouchcancel: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_unref(LTileLayer), {
        key: tileurl.value,
        url: tileurl.value,
        attribution: attribution.value,
        noWrap: true,
        options: tileLayerOptions.value
      }, null, 8, ["url", "attribution", "options"])),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pins ?? [], (pin, index) => {
        return (_openBlock(), _createBlock(_unref(LMarker), {
          key: index,
          "lat-lng": pin,
          options: markerOptions
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LIcon), {
              "icon-size": [24, 24],
              "icon-anchor": [12, 12],
              className: 'map-standalone-icon'
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "pin" }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["lat-lng"]))
      }), 128)),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["center", "zoom", "maxZoom", "options"]))
}
}

})